<!--
  @description 新开机申请单
  @author xiehan
  @date 2019/01/14
-->
<template>
  <div class="bootUpRequest">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="bootUpRequest@submit"
      :requestTitle="$t('cloudApplication.bootUpRequest')"
      :disAgreeInfo="disAgreeInfo"
      :status="status">
      <div slot="center">
        <el-row :gutter="10" style="margin-bottom: 10px;">
          <el-col :span="5">
            <span style="color: red;">*</span>
            <div v-text="$t('cloudApplication.models')" class="bootup-title"></div>
          </el-col>
          <el-col :span="5">
            <span style="color: red;">*</span>
            <div v-text="$t('cloudApplication.num')" class="bootup-title"></div>
          </el-col>
          <el-col :span="5">
            <span style="color: red;">*</span>
            <div v-text="$t('cloudApplication.disk')" class="bootup-title"></div>
          </el-col>
          <el-col :span="5">
            <span style="color: red;">*</span>
            <div v-text="$t('cloudApplication.network')" class="bootup-title"></div>
          </el-col>
          <el-col :span="4">
            <el-button icon="icon-xinzeng"
              type="primary"
              style="width: 70px;"
              @click="addHostInfo"></el-button>
          </el-col>
        </el-row>
        <el-form ref="hostForm" :model="hostForm" input-width="128px" label-width="0">
          <el-row :gutter="10" v-for="(item, index) in hostForm.hostInfoList" :key="item.itemKey">
            <el-col :span="5">
              <el-form-item>
                <g-select v-model="item.hostType" :list="select_hostType"></g-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-input-number v-model="item.count" :min="1"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :prop="'hostInfoList.' + index + '.disk'"
                :rules="[{ required: true, message: $t('common.entryTips') + $t('cloudApplication.disk'), trigger: 'blur' }]">
                <el-input v-model="item.disk"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :prop="'hostInfoList.' + index + '.networSegment'"
                :rules="[{ required: true, message: $t('common.entryTips') + $t('cloudApplication.network'), trigger: 'blur' }]">
                <el-input v-model="item.networSegment"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button icon="icon-shanchu1"
                style="width: 70px;"
                @click="deleteHostInfo(index)"></el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-table
          v-if="status === '5'"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        hostForm: {
          hostInfoList: [{
            count: 1,
            disk: '',
            hostType: '',
            networSegment: '',
            itemKey: new Date().getTime()
          }]
        },
        status: '1',
        disAgreeInfo: {},
        processTable: [],
        select_hostType: {},
        select_operate: {}
      }
    },
    components: {
      requestNote
    },
    methods: {
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('hosttype2'),
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        if (this.$route.query.status === '5') {
          this.getOrderInfo()
        }
        this.select_hostType = { ...this.dDictionary.hosttype2 }
        this.hostForm.hostInfoList[0].hostType = Object.keys(this.select_hostType)[0]
        this.select_operate = { ...this.dDictionary.workflowOperationType }
      },
      getRequestForm (val) {
        this.$refs['hostForm'].validate((valid) => {
          if (valid) {
            let hostInfoList = []
            this.hostForm.hostInfoList.map(item => {
              hostInfoList.push({
                count: item.count,
                disk: item.disk,
                hostType: item.hostType,
                networSegment: item.networSegment
              })
            })
            let saveInfo = {
              applicant: val.applicant,
              approver: val.approver,
              cc: val.cc,
              department: val.department,
              expectedTime: val.expectedTime,
              hostInfoList: hostInfoList,
              orderType: val.orderType,
              templateId: val.orderType,
              processInstanceId: val.processInstanceId,
              reason: val.reason,
              remarks: val.remarks,
              site: val.site
            }
            resApplicationBiz.submitApply(saveInfo).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'cloudApplication' })
            })
          } else {
            return false
          }
        })
      },
      addHostInfo () {
        this.hostForm.hostInfoList.push({
          count: 1,
          disk: '',
          hostType: Object.keys(this.select_hostType)[0],
          networSegment: '',
          itemKey: new Date().getTime()
        })
      },
      deleteHostInfo (index) {
        if (this.hostForm.hostInfoList.length === 1) return
        this.hostForm.hostInfoList.splice(index, 1)
      },
      getOrderInfo () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.disAgreeInfo = data
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.hostForm.hostInfoList = []
          this.disAgreeInfo.info.hostInfoList.map((item, index) => {
            this.hostForm.hostInfoList.push({
              count: item.count,
              disk: item.disk,
              hostType: this.select_hostType[item.hostType],
              networSegment: item.networSegment,
              itemKey: index
            })
          })
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'bootUpRequest' && from.name === 'cloudApplication') {
          this.status = '1'
          this.$nextTick(() => {
            this.$refs.requestNote.init()
          })
          this.hostForm.hostInfoList = [{
            count: 1,
            disk: '',
            hostType: '',
            networSegment: '',
            itemKey: new Date().getTime()
          }]
          this.getDic()
        } else if (to.name === 'bootUpRequest' && from.name === 'queryworkOrder') {
          this.status = '5'
          this.getDic()
        }
      }
    },
    mounted () {
      if (this.$route.query.status === '5') {
        this.status = '5'
      }
      this.getDic()
    }
  }
</script>

<style scoped>
  .bootup-title {
    height: 33px;
    line-height: 33px;
    display: inline-block;
  }
  .el-input-number {
    width: 128px;
  }
</style>